export const FIND_ASSIGNABLE_ASSETS_FOR_ADDON = `
  query FindAssignableAssetsForAddon($filter: FindAssignableAssetsForAddonFilter!, $page: PageRequest, $orderBy: OrderByInput) {
    addon {
      findAssignableAssetsForAddon(filter: $filter, page: $page, orderBy: $orderBy) {
        count
        limit
        offset
        items {
          id
          name
          productName
        }
      }
    }
  }
`;
